export {
	isConsultationHref,
	programSlugFromHref,
	trackDiscoveryLinkClick,
} from "@repo/tracking/discovery/lib/discovery-link-tracking";
